export default "__VITE_ASSET__CWYhCfY5__"